import { LoanFrequency } from '@/loan/enums/loan-frequency';

export const LOAN_FREQUENCY_TEXT_MAP: ReadonlyMap<LoanFrequency, string> = new Map<LoanFrequency, string>([
	[LoanFrequency.MONTHLY, 'Monthly'],
	[LoanFrequency.BI_WEEKLY, 'Bi-weekly (Every other week)'],
	[LoanFrequency.WEEKLY, 'Weekly'],
	[LoanFrequency.SEMI_MONTHLY, 'Semi-monthly (Twice a month)'],
]);
